<template>
  <form @submit.prevent="saveForm()">
    <div class="" style="width: auto">
      <section class="">
        <div class="flex items-center mb-2 ">
          <div class="w-1/2 px-2">
            <d-field label="Employment Status">
              <d-input v-model="mentorDataForm.employmentStatus" />
            </d-field>
          </div>
          <div class="w-1/2 px-2">
            <d-field label="Position">
              <d-input v-model="mentorDataForm.position" />
            </d-field>
          </div>
        </div>

        <div class="flex items-center mb-2 ">
          <div class="w-1/2 px-2">
            <d-field label="Year of Program">
              <d-input v-model="mentorDataForm.yearOfProgram" type="number" :has-counter="hasCounter" />
            </d-field>
          </div>
          <div class="w-1/2 px-2">
            <d-field label="Years Teaching Experience">
              <d-input v-model="mentorDataForm.yearsTeachingExperience" type="number" :has-counter="hasCounter" />
            </d-field>
          </div>
        </div>
        <div class="px-2 mb-2">
          <d-field label="Content Areas">
            <d-input v-model="mentorDataForm.contentAreas" type="textarea" />
          </d-field>
          <d-field label="Courses Currently Teaching">
            <d-input v-model="mentorDataForm.coursesCurrentlyTeaching" type="textarea" />
          </d-field>
          <d-field label="Other Courses Taught">
            <d-input v-model="mentorDataForm.otherCoursesTaught" type="textarea" />
          </d-field>
        </div>
        <div class="flex items-center mb-2 px-2">
          <div class="w-1/3">
            <d-field label="Currently Licensed Or Certified?">
              <d-switch v-model="mentorDataForm.currentlyLicensedOrCertified" />
            </d-field>
          </div>
        </div>
        <div class="mb-5 mt-5 cursor-pointer">
          <div class="flex flex-row" @click="expandFlexFields = !expandFlexFields">
            <d-icon icon="chevron-up" class="expand-icon cursor-pointer  px-3 transform" :class="{'rotate-180': expandFlexFields}" />
            <div class=" font-bold">
              Flex Fields
            </div>
          </div>
          <transition>
            <div v-if="expandFlexFields">
              <div class="flex items-center mt-5">
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex1')">
                    <d-input v-model="mentorDataForm.flex1" />
                  </d-field>
                </div>
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex2')">
                    <d-input v-model="mentorDataForm.flex2" />
                  </d-field>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex3')">
                    <d-input v-model="mentorDataForm.flex3" />
                  </d-field>
                </div>
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex4')">
                    <d-input v-model="mentorDataForm.flex4" />
                  </d-field>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex5')">
                    <d-input v-model="mentorDataForm.flex5" />
                  </d-field>
                </div>
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex6')">
                    <d-input v-model="mentorDataForm.flex6" />
                  </d-field>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex7')">
                    <d-input v-model="mentorDataForm.flex7" />
                  </d-field>
                </div>
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex8')">
                    <d-input v-model="mentorDataForm.flex8" />
                  </d-field>
                </div>
              </div>
              <div class="flex items-center">
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex9')">
                    <d-input v-model="mentorDataForm.flex9" />
                  </d-field>
                </div>
                <div class="w-1/2 px-2">
                  <d-field :label="getFlexFieldLabelValue('Flex10')">
                    <d-input v-model="mentorDataForm.flex10" />
                  </d-field>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </section>
      <footer>
        <div class="flex justify-end pt-5 w-full">
          <d-btn type="submit" class="mx-3">
            Save Changes
          </d-btn>
        </div>
      </footer>
    </div>
  </form>
</template>

<script>
  import axios from 'axios';

  export default {
    parent: true,
    props: {
      userId: {
        type: String,
        default: () => '',
      },
    },
    data: () => ({
      expandFlexFields: false,
      hasCounter: true,
      editMode: false,
      loadingData: false,
      saving: false,
      mentorDataForm: {
        employmentStatus: '',
        position: '',
        contentAreas: '',
        coursesCurrentlyTeaching: '',
        otherCoursesTaught: '',
        yearsTeachingExperience: 0,
        currentlyLicensedOrCertified: false,
        yearOfProgram: 0,
        flex1: '',
        flex2: '',
        flex3: '',
        flex4: '',
        flex5: '',
        flex6: '',
        flex7: '',
        flex8: '',
        flex9: '',
        flex10: '',
        userId: '',
      },
    }),

    mounted() {
      this.getMentorDataByUserId();
      this.getFlexFieldLabels();
    },

    methods: {
      async getMentorDataByUserId() {
        this.loadingData = true;
        const { data } = await axios.get(`/api/mentor-field-sets/user/${this.userId}`);
        if (data === '') {
          return;
        }
        this.mentorDataForm = data;
        this.loadingData = false;
      },

      async getFlexFieldLabels() {
        const { data } = await axios.get('/api/flex-fields/mentor');
        this.flexFields = data;
      },

      getFlexFieldLabelValue(field) {
        const flexFieldLabel = this.flexFields.find((m) => m.field === field);
        if (flexFieldLabel) {
          return flexFieldLabel.label;
        }
        return field;
      },

      async saveForm() {
        this.saving = true;
        try {
          if (this.mentorDataForm.id != null) {
            await axios.patch(`/api/mentor-field-sets/${this.mentorDataForm.id}`, this.mentorDataForm);
          } else {
            this.mentorDataForm.userId = this.userId;
            await axios.post('/api/mentor-field-sets/', this.mentorDataForm);
          }
          this.success();
        } catch (error) {
          this.danger(error.message);
        } finally {
          this.getMentorDataByUserId();
          this.saving = false;
        }
      },

      success() {
        this.$toast.open({
          message: 'Mentor Data updated successfully!',
          position: 'bottom',
          color: 'green-500',
        });
      },

      danger(errorMessage) {
        this.$toast.open({
          duration: 5000,
          message: `Error! Unable to save updated Mentor Data: ${errorMessage}`,
          position: 'bottom',
          color: 'red-500',
        });
      },

    },

  };
</script>